import { magicNumbers } from 'utils';

export const publicInitialState = {
  defaultLandingPageSelectBox: {
    hasFilter: false,
    isOpen: false,
    selectedValue: 'contents',
    componentName: 'defaultLandingPageSelectBox',
  },
  defaultPlatformSelectBox: {
    hasFilter: false,
    isOpen: false,
    selectedValue: 'news',
    componentName: 'defaultPlatformSelectBox',
  },
  defaultSubjectSelectBox: {
    hasFilter: false,
    isOpen: false,
    selectedValue: magicNumbers.SUBJECT_FILTER_DEFAULT_OPTION,
    componentName: 'defaultSubjectSelectBox',
  },
  defaultDateTimeSelectBox: {
    selectedTimeDuration: '1w',
    timeDuration: '1w',
    fromDate: undefined,
    toDate: undefined,
    hasDefaultDateTime: true,
    componentName: 'defaultDateTimeSelectBox',
  },
  defaultLanguageSelectBox: {
    hasFilter: false,
    isOpen: false,
    selectedValue: 'all',
    componentName: 'defaultLanguageSelectBox',
  },
  pageContentCountSlider: {
    hasFilter: false,
    isOpen: false,
    selectedValue: 10,
    componentName: 'pageContentCountSlider',
  },
  aiSummarizerPreview: {
    hasFilter: false,
    isOpen: false,
    selectedValue: false,
    componentName: 'aiSummarizerPreview',
  },
  wantTagContent: {
    hasFilter: false,
    isOpen: false,
    selectedValue: false,
    componentName: 'wantTagContent',
  },
  visiblePlatformTabs: {
    hasFilter: false,
    isOpen: false,
    selectedValue: [],
    componentName: 'visiblePlatformTabs',
  },
  morePlatformTabs: {
    hasFilter: false,
    isOpen: false,
    selectedValue: [],
    componentName: 'morePlatformTabs',
  },
};
